import css from 'styled-jsx/css';
import { colors, shadows } from '../../styles/theme';

const styles = theme => {
  return css.resolve`
    .holder-data {
      background: ${colors.white};
      border-radius: 20px;
      box-shadow: ${shadows.primary};
      display: flex;
      flex-direction: column;
      padding: 20px 20px 0px 20px;
      background: white;
      margin-bottom: 15px;
    }

    .holder-row {
      display: flex;
      padding-bottom: 10px;
    }

    .holder-data-info {
      color: ${theme.mainColor};
      text-align: right;
      flex: 0.5;
      padding-rigth: 20px;
      font-weight: 100;
    }

    .holder-data-data {
      color: ${theme.mainColor};
      text-align: left;
      flex: 0.5;
      padding-left: 20px;
      font-weight: bold;
      word-break: break-all;
    }
  `;
};
export default styles;
